/** @jsxImportSource @emotion/react */
import React, { PropsWithChildren, ReactElement, useMemo } from 'react';
import { DataFiltersModel, DataFiltersModelField } from '../../models';
import { filterByKeys } from '../../utils';
import { useLocationQuery } from '../../utils/hooks';
import { DateFilters, DateFiltersProps } from './DateFilters';

const defaultAvailableFilterKeys = [
  DataFiltersModelField.DateFrom,
  DataFiltersModelField.DateTo,
  DataFiltersModelField.DatePeriod,
];

interface Props extends DateFiltersProps {
  allowedKeys?: string[];
}

export function LocationDateFilters({
  allowedKeys = [],
  filters,
  ...props
}: PropsWithChildren<Props>): ReactElement {
  const location = useLocationQuery<DataFiltersModel>();

  const query = useMemo(
    () =>
      location.query
        ? filterByKeys(location.query, [
            ...defaultAvailableFilterKeys,
            ...allowedKeys,
          ])
        : {},
    [location.query],
  );

  const locationFilters = {
    ...query,
    ...(filters || {}),
  };

  const initialFiltering = (newFilters: DataFiltersModel, ...args) => {
    // location.setSearchParam(newFilters);

    // @ts-ignore
    props.initialFiltering(newFilters, ...args);
  };

  const onFiltersChange = (newFilters: DataFiltersModel, ...args) => {
    location.setSearchParam(newFilters);

    // @ts-ignore
    props.onFiltersChange(newFilters, ...args);
  };

  const onAndroidVersionsChange = (newFilters: DataFiltersModel, ...args) => {
    location.setSearchParam(newFilters);

    // @ts-ignore
    props.onAndroidVersionsChange(newFilters, ...args);
  };

  return (
    <DateFilters
      filters={locationFilters}
      {...props}
      onAndroidVersionsChange={onAndroidVersionsChange}
      initialFiltering={initialFiltering}
      onFiltersChange={onFiltersChange}
    />
  );
}
